module.exports = __webpack_public_path__ + "static/media/slide2.d7280035.webp";